import { basicI18Next } from './i18next.js';
export class AbstractTranslatableError extends Error {
    constructor(namespace, errorParams, defaultTFunction) {
        const { key, interpolationOptions } = errorParams;
        const tFunction = defaultTFunction || basicI18Next.i18nextInstance.t;
        const extendedInterpolationObject = Object.assign(Object.assign({}, interpolationOptions), { ns: namespace });
        const message = tFunction(key, Object.assign(Object.assign({}, extendedInterpolationObject), { lng: 'en' }));
        super(message);
        this.key = key;
        this.namespace = namespace;
        this.interpolationOptions = extendedInterpolationObject;
    }
}
